export { FileDropDirectiveModule } from "./file-drop-directive.module";
